import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IntegrationPartner } from 'src/app/models/ManageIntegrationModel';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PlatformApiService, PlanSearchCriteria } from 'src/app/services/platform-api.service';
import { Plan } from 'src/app/models/AccountModel';

@Component({
  selector: 'cw-ci-admin-integration-partner-edit',
  templateUrl: './integration-partner-edit.component.html',
  styleUrls: ['./integration-partner-edit.component.scss']
})
export class IntegrationPartnerEditComponent implements OnInit {
  _partner: IntegrationPartner;
  availablePlans: Plan[];

  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  @Input() set partner(value: IntegrationPartner) {
    this._partner = value;
    this.partnerForm.reset();
    if (this._partner.id) {
      this.partnerForm.controls.name.setValue(this._partner.name);
      this.partnerForm.controls.partnerKey.setValue(this._partner.partnerKey);
      this.partnerForm.controls.plan.setValue(this._partner.planId);
      this.partnerForm.controls.applicationUrl.setValue(this._partner.applicationUrl);
    }
  }

  partnerForm = new FormGroup ({
    name: new FormControl('', [Validators.required]),
    partnerKey: new FormControl('', [Validators.required]),
    plan: new FormControl('', [Validators.required]),
    applicationUrl: new FormControl('', [Validators.required]),
  });

  constructor(private _platformApi: PlatformApiService) { }

  ngOnInit() {
    this._platformApi.getPlans(new PlanSearchCriteria(true)).subscribe(plans => {
      this.availablePlans = plans.results;
    });
  }

  saveIntegrationPartner() {
    if (this.partnerForm.valid) {
      const savePartner = new IntegrationPartner({
        name: this.partnerForm.value.name,
        partnerKey: this.partnerForm.value.partnerKey,
        planId: this.partnerForm.value.plan,
        applicationUrl: this.partnerForm.value.applicationUrl,
      });
      if (this._partner.id) {
        savePartner.id = this._partner.id;
      }

      this._platformApi.saveIntegrationPartner(savePartner).subscribe(
        resp => {
          this.stateChange.emit({state: 'CREATESUCCESS'})
        }
      );
    }
  }

  cancelIntegrationPartner() {
    this.partnerForm.reset();
    this.stateChange.emit({state: 'EDITCANCEL'});
  }
}
